import React from 'react';
import { Link } from 'react-router-dom';
import styles from './NeedsAttentionPanel.module.css';
import Ico from '../common/Ico';

const ICO_ZAP = 'M13 2 3 14h9l-1 8 10-12h-9l1-8z';

export default function NeedsAttentionPanel({ items = [] }) {
  return (
    <div className={styles.panel}>
      <div className={styles.header}>
        <Ico d={ICO_ZAP} size={14} style={{ color: 'var(--fg-muted)' }} />
        Needs attention
      </div>
      {items.length === 0 ? (
        <div className={styles.empty}>Nothing needs attention right now.</div>
      ) : (
        <div className={styles.list}>
          {items.map((item, i) => (
            <Link key={i} to={item.to} className={styles.item}>
              <Ico d={item.icon} size={13} strokeWidth={2} style={{ color: item.iconColor || 'var(--blue-700)' }} />
              {item.text}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
